(function($) {
	$('.svg-convert').svgConvert({
		onComplete: function() {
			Foundation.reInit('equalizer');
		}
	});

	document.addEventListener('lazyunveilread', function(e){
		// Foundation.reInit('equalizer');
	});

	$('img.lazyload').on('load',function(){
		if (typeof $(this).parent().closest('.row').data('equalizer') !== 'undefined') {
			$(window).trigger('resize'); 
		}
	});

	$('.testimonials-slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: false
	});

	$('.clients-slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		arrows: false,
		autoplaySpeed: 4000,
		autoplay: true
	});

	$('.partners-slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		autoplaySpeed: 4000,
		arrows: false,
		autoplay: true
	});

	$(window).bind("load", function() {
		setTimeout(function() {
	    	var iframedefer = document.getElementsByTagName('iframe');
	    	for (var i = 0; i < iframedefer.length; i++) {
		    	if(iframedefer[i].getAttribute('data-src')) {
		    		iframedefer[i].setAttribute('src',iframedefer[i].getAttribute('data-src'));
		    	} 
	    	} 
	    }, 1000);
	});

	$(document).ready(function($) {
		$(".wpcf7-form-control-wrap").on('touchstart mousedown', function(e){
			$obj = $("span.wpcf7-not-valid-tip, div.wpcf7-response-output", this);
			$obj.css('display','none');
		});
	});

})( jQuery );